import { connect } from 'react-redux';
import Lazyload from 'react-lazyload';
import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import useSWR from 'swr';

import { Picture } from './styled';

function ShowImage({ medium, mediumLoading, isCarousel }) {
  const { data } = useSWR(medium?.['canvas-image-id'] ? `/v2/media/${medium?.['canvas-image-id']}` : null);
  let updatedMedium = data?.data?.data?.attributes || medium
  return <>
    <Picture isCarousel={isCarousel} hasCanvasId={medium?.['canvas-image-id']}>
      <source srcSet={get(updatedMedium, '["image-versions"][2].url')} />
      <source srcSet={get(updatedMedium, '["image-versions"][5].url')} media="(max-width: 430px)" />
      <img
        src={updatedMedium.tmpUrl || updatedMedium['asset-url']}
        style={getFilterStyle(mediumLoading)}
        alt=""
      />
    </Picture>
  </>
}

const getFilterStyle = mediumLoading => ({
  filter: (mediumLoading && 'grayscale') || 'none',
});

const ImageMedium = ({ height, ...props }) => window?.location?.pathname.includes('/book-creation') ? <ShowImage {...props} /> :
  (
    <Lazyload height={height} offset={600} once>
      <ShowImage {...props} />
    </Lazyload>
  );

ImageMedium.propTypes = {
  medium: PropTypes.shape({}).isRequired,
  mediumLoading: PropTypes.bool,
  height: PropTypes.number,
  isCarousel: PropTypes.bool,
};

ImageMedium.defaultProps = {
  mediumLoading: false,
  height: 100,
  isCarousel: false,
};

const mapStateToProps = (state, ownProps) => ({
  medium: state.entities.images[ownProps.id],
  mediumLoading: isNumber(state.storyMedia.uploadBatch.map(item => item.id).includes(ownProps.id)),
  height: Number((ownProps.height || '').replace('px', '')),
});

export default connect(mapStateToProps)(ImageMedium);
